import { render, staticRenderFns } from "./TreeCardIcon.vue?vue&type=template&id=20f0763e"
import script from "./TreeCardIcon.vue?vue&type=script&lang=js"
export * from "./TreeCardIcon.vue?vue&type=script&lang=js"
import style0 from "./TreeCardIcon.vue?vue&type=style&index=0&id=20f0763e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports